// export const apiAddress = "http://116.203.132.48"
export const apiAddress = "https://api.ghalichin.com";
//export const apiAddress = "http://188.121.121.204/api";
// export const apiAddress = "http://127.0.0.1:8000"
// export const publicAPIKey = "pqRQd8UdQpFVvzu3fsZW4PBhm9wtb9kkJ7a23UVQ"

export const shanehList = {
  // "320": [960, 1300],
  // "480": [1500],
  //  "500": [1000, 1200, 1500],
  700: [2100, 2550, 3000],
  1000: [3000],
  1200: [3600],
  //  "1250": [3750],
  1500: [4500],
  //  "1600": [4800],
};

export const densitiesList = [2100, 2550, 3000, 3600, 4500];

export const supportedLanguages = ["fa", "en", "ar", "du"];

export default apiAddress;